module.exports = __webpack_public_path__ + "img/NIS.7b5e4c25.png";